import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getSearchSummaryUsers } from "../../Admin-Api/searchSummaryUsers";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const PamDetails = () => {
    const { pamCode } = useParams();
    const [data, setData] = useState<any>(null);
    console.log("data", data?.users[0]?.user);

    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { fromDate, toDate, pamCode: prevPamCode, pamSearchData } = location.state || {};

    useEffect(() => {
        const fetchData = async () => {
            if (!pamCode) return;

            setIsLoading(true);

            try {
                const token = localStorage.getItem("token");
                if (!token) throw new Error("No token");

                const cleanPamCode = pamCode.replace(/-/g, "");

                const res = await getSearchSummaryUsers(cleanPamCode, token);

                setData(res);
            } catch (error) {
                toast.error("Failed to fetch PAM details");
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [pamCode]);

    const handleBack = () => {
        navigate("/search-summary", {
            state: {
                ...location.state,
                restoreSearch: true
            }
        });
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">

                {/* 🔙 Header */}
                <div className="flex items-center gap-3 mb-6">
                    <button
                        onClick={handleBack}
                        className="text-xl font-bold text-gray-700 hover:text-gray-900"
                    >
                        &lt;
                    </button>
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-700">
                        PAM Code Details
                    </h2>
                </div>

                {/* 📦 Summary Card */}
                {data && (
                    <div className="bg-white rounded-lg shadow-md p-5 mb-6">
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">

                            <div>
                                <p className="text-sm text-gray-500">PAM Code</p>
                                <p className="text-base font-semibold text-gray-800">
                                    {pamCode}
                                </p>
                            </div>

                            <div>
                                <p className="text-sm text-gray-500">Total Searches</p>
                                <p className="text-base font-semibold text-gray-800 text-center">
                                    {data.searchCount}
                                </p>
                            </div>

                        </div>
                    </div>
                )}

                {/* 🔄 Loading */}
                {isLoading && (
                    <p className="text-gray-500 text-sm">Loading details...</p>
                )}

                {/* 📊 Table */}
                {data && data.users && data.users.length > 0 && (
                    <div className="bg-white rounded-lg shadow-md overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="min-w-full text-sm">

                                <thead className="bg-blue-600">
                                    <tr>
                                        <th className="px-4 py-3 text-center text-white font-medium">User Id</th>
                                        <th className="px-4 py-3 text-center text-white font-medium">User Name</th>
                                        <th className="px-4 py-3 text-center text-white font-medium">Email-Id</th>
                                        <th className="px-4 py-3 text-center text-white font-medium">Phone Number</th>
                                        <th className="px-4 py-3 text-center text-white font-medium">Created Date</th>
                                        <th className="px-4 py-3 text-center text-white font-medium">Searched Date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {data.users.map((item: any, index: number) => (
                                        <tr
                                            key={index}
                                            className="border-t hover:bg-gray-50"
                                        >
                                            <td className="px-4 py-3 text-center font-medium text-gray-800">
                                                {item.user?.id || "-"}
                                            </td>

                                            <td className="px-4 py-3 text-center font-medium text-gray-800">
                                                {item.user?.userName || "User Info Not Found"}
                                            </td>

                                            <td className="px-4 py-3 text-center text-gray-600 break-all">
                                                {item.user?.email || "-"}
                                            </td>

                                            <td className="px-4 py-3 text-center text-gray-600">
                                                {item.user?.phoneNumber || "-"}
                                            </td>

                                            <td className="px-4 py-3 text-center text-gray-500">
                                                {item.user?.createdDate
                                                    ? new Date(item.user.createdDate).toLocaleDateString()
                                                    : "-"}
                                            </td>

                                            <td className="px-4 py-3 text-center text-gray-500">
                                                {item.searchedAt
                                                    ? new Date(item.searchedAt).toLocaleDateString()
                                                    : "-"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                        </div>
                    </div>
                )}

                {/* 🚫 Empty State */}
                {data && data.users && data.users.length === 0 && !isLoading && (
                    <div className="bg-white rounded-lg shadow-md p-8 text-center">
                        <p className="text-gray-600 font-medium">
                            No user-level data available
                        </p>
                        <p className="text-sm text-gray-400 mt-1">
                            This PAM code has searches but no user records
                        </p>
                    </div>
                )}

            </div>
        </div>
    );
};

export default PamDetails;